import RelativeBrandsAnalysis from './relativeBrandsAnalysis'
export default RelativeBrandsAnalysis
